exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrapper[data-v-a563d146]{display:flex;flex-direction:column;background:transparent;width:100%;border-radius:5px;border:.5px solid #f6fafd;font-family:Bitter,Georgia,Cambria,Times New Roman,Times,serif}.back[data-v-a563d146]{color:#e53e3e;cursor:pointer;margin-bottom:5px;text-decoration:underline}", ""]);

// exports
